/**
 * Get the header offset
 * @param headerRef - The header ref
 * @param bounceHeader - The bounce header
 * @returns The header offset
 */
const getHeaderOffset = (
  headerRef: React.RefObject<HTMLDivElement>,
  bounceHeader: HTMLElement | null
): number =>
  (headerRef.current?.offsetHeight || 0) + (bounceHeader?.offsetHeight || 0);

export default getHeaderOffset;
